import React, { useState } from "react";
import styles from "./CardSubject.module.scss";
import useComponentDimension from "util/useComponentDimension";
import { Badge, Space } from "antd";
import _ from "lodash";
import { useDataStore } from "store/DataStoreContext";

const CardSubject = (props) => {
  const {
    name,
    banner,
    bannerColorCode,
    onClick,
    info,
    itemId,
    selected,
    comingSoon,
    subjectGroup,
    subject,
    activeLevel,
  } = props;

  const {
    state: { educationType },
  } = useDataStore();

  const [isIMGError, setIsImageError] = useState(false);
  const [ref, dimensions] = useComponentDimension();

  const handleImageError = () => {
    setIsImageError(true);
  };

  return (
    <Space>
      {comingSoon ? (
        <Badge.Ribbon text={"Coming Soon"}>
          <div
            role="button"
            tabIndex={0}
            key={itemId}
            className={styles.card}
            ref={ref}
            style={{ cursor: "not-allowed !important" }}
          >
            <div card-itemid={`card-subject`} className={styles.divRegtangle}>
              {isIMGError ? (
                <div
                  className={styles.banner_color}
                  style={{
                    backgroundColor: `${bannerColorCode}`,
                    height: `${dimensions.width}px`,
                  }}
                ></div>
              ) : (
                <img
                  style={{
                    border: `2px solid ${_.get(
                      _.find(educationType.data, {
                        id: educationType.activeLevel,
                      }),
                      "strokeSubject"
                    )}`,
                  }}
                  alt={name}
                  src={_.get(
                    _.find(
                      _.get(
                        _.find(subject.level, { id: activeLevel }),
                        "subjectGroup"
                      ),
                      {
                        id: subjectGroup,
                      }
                    ),
                    "squareBanner"
                  )}
                  className={styles.banner}
                  onError={handleImageError}
                />
              )}
            </div>
            <div className={styles.titleName} style={{ marginBottom: "16px" }}>
              {name}{" "}
              {info && <span className={styles.subTitleName}>({info})</span>}
            </div>
          </div>
        </Badge.Ribbon>
      ) : (
        <div
          role="button"
          tabIndex={0}
          key={itemId}
          className={styles.card}
          ref={ref}
        >
          <div
            card-itemid={`card-subject`}
            className={styles.divRegtangle}
            onClick={onClick}
          >
            {isIMGError ? (
              <div
                className={styles.banner_color}
                style={{
                  backgroundColor: `${bannerColorCode}`,
                  height: `${dimensions.width}px`,
                }}
              ></div>
            ) : (
              <img
                style={{
                  border: `2px solid ${_.get(
                    _.find(educationType.data, {
                      id: educationType.activeLevel,
                    }),
                    "strokeSubject"
                  )}`,
                }}
                alt={name}
                src={_.get(
                  _.find(
                    _.get(
                      _.find(subject.level, { id: activeLevel }),
                      "subjectGroup"
                    ),
                    {
                      id: subjectGroup,
                    }
                  ),
                  "squareBanner"
                )}
                className={styles.banner}
                onError={handleImageError}
              />
            )}
          </div>
          <div className={styles.titleName} style={{ marginBottom: "16px" }}>
            {name}{" "}
            {info && <span className={styles.subTitleName}>({info})</span>}
          </div>
        </div>
      )}
    </Space>
  );
};
export default CardSubject;
